const API = process.env.REACT_APP_BACKEND_URL;

const refDomain = () => {
  try {
    if (!document.referrer) return "";
    const host = new URL(document.referrer).hostname;
    return host === window.location.hostname ? "" : host;
  } catch {
    return "";
  }
};

const post = (payload) =>
  fetch(`${API}/api/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});

const tz = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
};

export const trackPageview = (path) => {
  if (path.startsWith("/admin")) return;
  post({ type: "pageview", path, ref: refDomain(), tz: tz() });
};

export const trackEvent = (event) => {
  post({ type: "event", event, path: window.location.pathname });
};
